module.exports = __webpack_public_path__ + "assets/mobile_back_blue-8f2844.svg";